export function initLocationIndexDirectory() {
  const $module = $('.location-index-directory');
  if (!$module.length) return;

  const $gridView   = $module.find('.js-li-grid-view');
  const $listView   = $module.find('.js-li-list-view');
  const $toggleGrid = $module.find('.js-li-toggle-grid');
  const $toggleList = $module.find('.js-li-toggle-list');
  const $alphaLinks = $module.find('.location-index-directory__alpha-link:not(.is-disabled)');

  // View toggle
  $toggleGrid.click(function () {
    $gridView.removeClass('is-hidden');
    $listView.addClass('is-hidden');
    $toggleGrid.addClass('is-active');
    $toggleList.removeClass('is-active');
  });

  $toggleList.click(function () {
    $listView.removeClass('is-hidden');
    $gridView.addClass('is-hidden');
    $toggleList.addClass('is-active');
    $toggleGrid.removeClass('is-active');
  });

  // Alphabet navigation — scroll to section in active view
  $alphaLinks.click(function (e) {
    e.preventDefault();
    const letter = $(this).data('letter');
    const $activeView = $listView.hasClass('is-hidden') ? $gridView : $listView;
    const $target = $activeView.find('[data-letter="' + letter + '"]');

    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 120 }, 400);
    }
  });

}
